import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

export function ConsentContent() {
  const { t } = useTranslation();
  
  const acknowledgmentItems = t('consent.acknowledgment.items', { returnObjects: true }) || [];
  
  return (
    <div className="px-6 pt-5 pb-4">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">
        {t('consent.title')}
      </h3>
      
      <div className="prose prose-indigo max-w-none overflow-y-auto max-h-[60vh]">
        <h4>{t('consent.welcome')}</h4>
        <p className="text-sm text-gray-600">{t('consent.introduction')}</p>

        <div className="mt-4">
          <h5 className="font-semibold">{t('consent.purpose.title')}</h5>
          <p className="text-sm text-gray-600">{t('consent.purpose.content')}</p>

          <h5 className="font-semibold mt-4">{t('consent.data.title')}</h5>
          <p className="text-sm text-gray-600">{t('consent.data.content')}</p>

          <h5 className="font-semibold mt-4">{t('consent.acknowledgment.title')}</h5>
          <ul className="text-sm text-gray-600 list-disc pl-5">
            {Array.isArray(acknowledgmentItems) && acknowledgmentItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
} 